import { Box, Grid, Typography } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import moment from 'moment'
import { useEffect, useState } from 'react'
import {
  alterarDadosBancario,
  excluirDadosBancariosMedico,
  IDadosBancario,
  obterDadosBancario,
  salvarDadosBancario,
  SalvarDadosBancarioRequest
} from 'src/api/dados-bancario'
import {
  salvarMembroEquipe,
  SalvarMembroEquipeCommand
} from 'src/api/membroEquipe'
import ModalLiberarAcesso from 'src/components/modals/ModalSenhaMaster'
import Button from 'src/components/ui/Button'
import Ubox from 'src/components/ui/Ubox'
import { SynPerfis } from 'src/core/consts/synPerfis'
import tipoDadosBancario from 'src/core/consts/tipoDadosBancario'
import {
  showNotification,
  showNotificationErrorAPI
} from 'src/core/helpers/notification'
import useAuth from 'src/hooks/useAuth'
import { SenhaMasterCommand } from 'src/types'
import FormPF from './formFisica/formPF'
import FormPJ from './formJuridica/formPJ'
import { IFormsCadastro } from './interface'
import LoadingGeral from 'src/components/ui/LoadingGeral'

type Props = {
  dadosBancarios?: (data: IFormsCadastro) => void
  ignorarSubmit?: boolean
  handleNext?: () => void
  handleBack?: () => void
  activeTab?: number
  verBotao?: boolean
  dadosBancarioId?: string
  id?: string
  tipoConta?: number
  handleAfterSubmit?: (atualizou, id?, tipoConta?) => void
  ehMembroEquipe?: boolean
  isParceiro?: boolean
}

export default function CadastroDadosBancarios({
  dadosBancarios,
  handleNext,
  handleBack,
  ignorarSubmit,
  verBotao,
  dadosBancarioId,
  id,
  tipoConta,
  handleAfterSubmit,
  ehMembroEquipe,
  isParceiro
}: Props) {
  const [selectPf, setSelectPf] = useState(false)
  const [selectPj, setSelectPj] = useState(isParceiro)

  const [submitting, setSubmitting] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [
    editarDadosBancarios,
    setEditarDadosBancarios
  ] = useState<IDadosBancario>()

  const { perfilAtual } = useAuth()
  const [mostrarModalSenhaMaster, setMostrarModalSenhaMaster] = useState<boolean>(false)
  const [excluindo, setExcluindo] = useState<boolean>(false)

  const podeExcluir =
    (perfilAtual === SynPerfis.OPERACIONAL ||
      perfilAtual === SynPerfis.SUPER_ADMIN) &&
    tipoConta === tipoDadosBancario.Medico &&
    (!!dadosBancarioId || !!editarDadosBancarios)

  const handleConfirmarExclusao = async (
    confirmado: boolean,
    command?: SenhaMasterCommand
  ) => {
    if (!confirmado) return
    if (!id) return

    try {
      setExcluindo(true)
      await excluirDadosBancariosMedico(id, command?.senhaMaster)
      showNotification(
        'Sucesso',
        'Dados bancários do médico excluídos com sucesso.',
        'success',
        true
      )
      if (handleAfterSubmit) {
        handleAfterSubmit(true, id, tipoConta)
      }
    } catch (error) {
      showNotificationErrorAPI(error)
    } finally {
      setExcluindo(false)
    }
  }

  const handleActivePF = () => {
    setSelectPf(true)
    setSelectPj(false)
  }
  const handleActivePJ = () => {
    setSelectPj(true)
    setSelectPf(false)
  }
  const handleCloseModal = () => {
    setSelectPf(false)
    setSelectPj(false)
  }

  const handleNextWrapper = () => {
    handleNext()
  }

  const handleBackWrapper = () => {
    handleBack()
  }

  function handleSubmit(data: IFormsCadastro) {
    if (!ignorarSubmit) {
      return onSubmit(data)
    } else {
      dadosBancarios(data)
    }
  }

  const onSubmit = async (data: IFormsCadastro) => {
    try {
      var dataNascimento = moment(data.birthdate, 'DD/MM/YYYY').toISOString()

      const payloadDadosBancarios = {
        nomeBanco: data.nomeBanco,
        agencia: data.agencia,
        digitoAgencia: data.digitoAgencia,
        numeroConta: data.numeroConta,
        digitoConta: data.digitoConta,
        codigoBanco: data.codigoBanco,
        tipoConta: data.tipoConta,
        cpfCnpj: data.cpfCnpj,
        ...(!!data.companyName && {
          companyName: data.companyName,
          tradingName: data.nomeBanco,
          companyEmail: data.companyEmail,
          companyDocument: data.companyDocument,
          annualRevenue: data.annualRevenue,
          companyPhoneNumbers: data.companyPhoneNumbers,
          corporationType: data.corporationType || undefined,
          foundingDate: data.foundingDate
            ? moment(data.foundingDate, 'DD/MM/YYYY').toISOString()
            : undefined
        }),
        name: !!data.companyName ? data.name : data.nomeBanco,
        email: data.email,
        document: data.document,
        birthdate: dataNascimento,
        monthlyIncome: data.monthlyIncome,
        professionalOccupation: data.professionalOccupation,
        phoneNumbers: data.phoneNumbers,
        siteUrl: data.siteUrl,
        selfDeclaredLegalRepresentative: data.selfDeclaredLegalRepresentative,
        address: {
          cep: data.cep,
          city: data.city,
          complementary: data.complementary,
          neighborhood: data.neighborhood,
          streetNumber: data.streetNumber,
          referencePoint: data.referencePoint,
          state: data.state,
          street: data.street
        },
        ...(!!data.companyCep && {
          mainAddress: {
            cep: data.companyCep,
            city: data.companyCity,
            complementary: data.companyComplementary,
            neighborhood: data.companyNeighborhood,
            streetNumber: data.companyStreetNumber,
            referencePoint: data.companyReferencePoint,
            state: data.companyState,
            street: data.companyStreet
          }
        })
      }
      const request = payloadDadosBancarios as SalvarDadosBancarioRequest
      const requestMenbro = payloadDadosBancarios as SalvarMembroEquipeCommand
      if (tipoConta === tipoDadosBancario.Medico) {
        request.medicoId = id
      }
      if (tipoConta === tipoDadosBancario.Parceiro) {
        request.parceiroId = id
      }
      setSubmitting(true)
      if (dadosBancarioId) {
        request.id = dadosBancarioId
        if (ehMembroEquipe) {
          await salvarMembroEquipe(requestMenbro)
        } else {
          await alterarDadosBancario(request)
        }
      } else {
        if (ehMembroEquipe) {
          await salvarMembroEquipe(requestMenbro)
        } else {
          await salvarDadosBancario(request)
        }
      }
      showNotification(
        'Parabéns',
        'Dados bancários configurados com sucesso.',
        'success',
        true
      )
      setTimeout(() => handleAfterSubmit(true, id, tipoConta), 300)
      setSubmitting(false)
    } catch (error) {
      setSubmitting(false)
      showNotificationErrorAPI(error)
    }
  }

  async function obterDadosBancarioPorId() {
    try {
      if (dadosBancarioId) {
        setLoading(true)
        const { data } = await obterDadosBancario(dadosBancarioId)
        setEditarDadosBancarios(data)
        setLoading(false)
      }
    } catch (error) {
      showNotificationErrorAPI(error)
    }
  }

  useEffect(() => {
    if (!loading) obterDadosBancarioPorId()
  }, [])

  useEffect(() => {
    if (editarDadosBancarios) {
      if (editarDadosBancarios.pessoaJuridica === true) {
        setSelectPj(true)
        setSelectPf(false)
      } else {
        setSelectPf(true)
        setSelectPj(false)
      }
    }
  }, [tipoConta, loading])

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
          margin: '25px 0px 25px 0px'
        }}
      >
        {(!isParceiro &&
          <Box
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '6px'
            }}
          >
            <span>Selecione a opção desejada</span>
            <div style={{ display: 'flex', gap: '12px' }}>
              <Button
                variant="outlined"
                onClick={handleActivePF}
                color={selectPf ? 'secondary' : 'primary'}
                disabled={!!editarDadosBancarios}
                id="button-pessoa-fisica"
              >
                Pessoa Fisica
              </Button>
              <Button
                variant="outlined"
                onClick={handleActivePJ}
                color={selectPj ? 'secondary' : 'primary'}
                disabled={!!editarDadosBancarios}
                id="button-pessoa-juridica"
              >
                Pessoa Juridica
              </Button>
            </div>
          </Box>
        )}
      </div>
      <ModalLiberarAcesso
        copy="A exclusão dos dados bancários do médico exige autorização com a senha master."
        titulo="Excluir dados bancários"
        open={mostrarModalSenhaMaster}
        handleClose={() => setMostrarModalSenhaMaster(false)}
        isDelete={true}
        confirmButtonText="Excluir"
        onConfirm={handleConfirmarExclusao}
      />
      {podeExcluir && (
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          style={{
            padding: '12px 16px',
            marginBottom: '16px',
            backgroundColor: '#fdecea',
            borderRadius: '8px',
            border: '1px solid #f5c6cb'
          }}
        >
          <Box>
            <Typography
              variant="subtitle2"
              style={{ color: '#721c24', fontWeight: 600 }}
            >
              Dados bancários vinculados
            </Typography>
            <Typography variant="caption" style={{ color: '#721c24' }}>
              Excluir os dados bancários deste médico exige autorização com a senha master.
            </Typography>
          </Box>
          <Button
            variant="contained"
            style={{ backgroundColor: '#cc3025', color: '#fff' }}
            startIcon={<DeleteIcon />}
            onClick={() => setMostrarModalSenhaMaster(true)}
            id="button-excluir-dados-bancarios-medico"
            loading={excluindo}
            disabled={excluindo || loading || submitting}
          >
            Excluir
          </Button>
        </Box>
      )}
      {(loading || submitting) && <LoadingGeral />}
      <Ubox render={selectPf === true}>
        {(!dadosBancarioId ||
          (!!dadosBancarioId && !!editarDadosBancarios)) && (
          <FormPF
            open={selectPf}
            onClose={handleCloseModal}
            dadosBancariosUsuario={handleSubmit}
            ignorarSubmit={ignorarSubmit}
            showNext={handleNextWrapper}
            showBack={handleBackWrapper}
            editarDadosBancarios={editarDadosBancarios}
          />
        )}
      </Ubox>
      <Ubox render={selectPj === true}>
        {(!dadosBancarioId ||
          (!!dadosBancarioId && !!editarDadosBancarios)) && (
          <FormPJ
            open={selectPj}
            onClose={handleCloseModal}
            dadosBancariosUsuario={handleSubmit}
            ignorarSubmit={ignorarSubmit}
            showNext={handleNextWrapper}
            showBack={handleBackWrapper}
            editarDadosBancarios={editarDadosBancarios}
          />
        )}
      </Ubox>
      {verBotao && (
        <Ubox render={!selectPf && !selectPj}>
          <Grid item xs={12} sm={2}>
            <Button
              type="button"
              fullWidth
              variant="contained"
              color="default"
              onClick={handleBackWrapper}
              id="button-voltar-new-cadastro"
            >
              Voltar
            </Button>
          </Grid>
        </Ubox>
      )}
    </>
  )
}
